import { render, staticRenderFns } from "./tabs-controller.vue?vue&type=template&id=09a71e53&scoped=true"
import script from "./tabs-controller.vue?vue&type=script&lang=ts"
export * from "./tabs-controller.vue?vue&type=script&lang=ts"
import style0 from "./tabs-controller.vue?vue&type=style&index=0&id=09a71e53&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09a71e53",
  null
  
)

export default component.exports